export default __webpack_public_path__ + "static/media/MarkCuban.76b83f88.svg";